/* eslint-disable arrow-body-style */
import { Container, Paper, Text } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

const TechnicalRequirementsTab = () => {
  const { lang } = useTranslation('client')
  return (
    <Container size="sm">
      <Paper>
        {lang === 'en' ? (
          <div style={{ marginBottom: 30 }}>
            <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
              Technical Requirements
            </Text>
            <Text size="lg">
              To ensure optimal performance and compatibility when accessing our
              services, please ensure that your device meets the following
              technical requirements:
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Internet Connection
            </Text>
            <Text size="lg">
              A stable internet connection is required to access our online
              platform and resources. We recommend a broadband connection with a
              minimum speed of [specify speed] for the best experience.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Supported Devices
            </Text>
            <Text size="lg">
              Our platform is compatible with a wide range of devices, including
              desktop computers, laptops, tablets, and smartphones. For the best
              viewing experience, we recommend using devices with the following
              specifications:
            </Text>

            <Text size="lg">
              <span className="font-bold"> Desktop/Laptop: </span> Windows 10 or
              macOS X with the latest version of Google Chrome, Mozilla Firefox,
              Microsoft Edge, or Safari.
            </Text>
            <Text size="lg">
              <span className="font-bold"> Tablet/Smartphone: </span> iOS 11+ or
              Android 8+ with the latest version of Google Chrome or Safari.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Software Requirements
            </Text>
            <Text size="lg">
              Ensure that your device has the latest version of web browsers
              installed, along with any necessary plugins or extensions required
              to access interactive content.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Screen Resolution
            </Text>
            <Text size="lg">
              We recommend a minimum screen resolution of [specify resolution]
              for optimal viewing and usability of our platform and resources.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Cookies and JavaScript
            </Text>
            <Text size="lg">
              Please enable cookies and JavaScript in your web browser settings
              to ensure full functionality and access to interactive features on
              our platform.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Additional Requirements
            </Text>
            <Text size="lg">
              Depending on the specific services or courses you plan to access,
              there may be additional technical requirements such as specific
              software applications or hardware peripherals. Please refer to the
              course or service description for details.
            </Text>

            <Text size="lg">
              If you encounter any technical issues or have questions about the
              technical requirements, our technical support team is available to
              assist you. Please contact us using the information provided at
              the end of this document.
            </Text>
          </div>
        ) : (
          <div style={{ marginBottom: 30 }}>
            <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
              المتطلبات التقنية
            </Text>
            <Text size="lg">
              لضمان الأداء الأمثل والتوافق عند الوصول إلى خدماتنا، يرجى التأكد
              من أن جهازك يفي بالمتطلبات التقنية التالية:
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              اتصال الإنترنت
            </Text>
            <Text size="lg">
              يتطلب الوصول إلى منصتنا عبر الإنترنت اتصالًا ثابتًا بالإنترنت.
              نوصي باتصال عريض النطاق بسرعة لا تقل عن [حدد السرعة] لتجربة أفضل.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              الأجهزة المدعومة
            </Text>
            <Text size="lg">
              منصتنا متوافقة مع مجموعة متنوعة من الأجهزة، بما في ذلك أجهزة
              الكمبيوتر المكتبية والمحمولة والأجهزة اللوحية والهواتف الذكية.
              لتجربة مشاهدة أفضل، نوصي باستخدام الأجهزة التي تحتوي على المواصفات
              التالية:
            </Text>

            <Text size="lg">
              <span className="font-bold"> الكمبيوتر المكتبي/المحمول: </span>{' '}
              Windows 10 أو macOS X مع أحدث إصدار من Google Chrome أو Mozilla
              Firefox أو Microsoft Edge أو Safari.
            </Text>
            <Text size="lg">
              <span className="font-bold"> اللوحة/الهاتف الذكي: </span> iOS 11+
              أو Android 8+ مع أحدث إصدار من Google Chrome أو Safari.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              متطلبات البرمجيات
            </Text>
            <Text size="lg">
              تأكد من أن جهازك يحتوي على أحدث إصدار من متصفحات الويب المثبتة،
              بالإضافة إلى أي ملحقات أو توسعات ضرورية للوصول إلى المحتوى
              التفاعلي.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              دقة الشاشة
            </Text>
            <Text size="lg">
              نوصي بدقة شاشة بحد أدنى تبلغ [حدد الدقة] للمشاهدة والاستخدام
              الأمثل لمنصتنا والموارد.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              ملفات تعريف الارتباط وJavaScript
            </Text>
            <Text size="lg">
              يرجى تمكين ملفات تعريف الارتباط وJavaScript في إعدادات متصفح الويب
              الخاص بك لضمان الوظائف الكاملة والوصول إلى الميزات التفاعلية على
              منصتنا.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              متطلبات إضافية
            </Text>
            <Text size="lg">
              يمكن أن تكون هناك متطلبات تقنية إضافية حسب الخدمات أو الدورات
              المحددة التي تخطط للوصول إليها، مثل تطبيقات البرمجيات أو الأجهزة
              الطرفية الخاصة. يرجى الرجوع إلى وصف الدورة أو الخدمة للحصول على
              التفاصيل.
            </Text>

            <Text size="lg">
              إذا واجهت أي مشاكل تقنية أو كانت لديك أسئلة حول المتطلبات التقنية،
              فإن فريق الدعم الفني الخاص بنا متاح لمساعدتك. يرجى الاتصال بنا
              باستخدام المعلومات المقدمة في نهاية هذا الوثيقة.
            </Text>
          </div>
        )}
      </Paper>
    </Container>
  )
}

export default TechnicalRequirementsTab
